import React, { useState, useEffect } from "react";
import { Box } from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import { PurchasesContextProvider } from "../../Context/PurchasesContext";
import { ProductsContextProvider } from "../../Context/ProductsContext";
import { SuppliersContextProvider } from "../../Context/SuppliersContext";
import PurchaseDetails from "./PurchaseDetails";
import useFetch from "../../../hooks/useFetch";
import Body from "../../Common/Body";

const Purchase = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [purchase, setPurchase] = useState({});
  const { id } = useParams();
  const { get } = useFetch();

  useEffect(() => {
    if (id !== "nueva") {
      get(`/suppliers/purchases/${id}`)
        .then(async (res) => {
          setPurchase(res);
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => setIsLoading(false));
    }
  }, []);

  if (id === "nueva") {
    return null;
  }

  return (
    <SuppliersContextProvider>
      <PurchasesContextProvider>
        <ProductsContextProvider>
          <Body
            title={`Compra ${
              purchase.id + " (Estado: " + purchase.status + ")"
            }`}
            isLoading={isLoading}
          >
            <Box p={["0", "0.75rem"]}>
              <PurchaseDetails
                purchase={purchase}
                updatePurchase={setPurchase}
              ></PurchaseDetails>
            </Box>
          </Body>
        </ProductsContextProvider>
      </PurchasesContextProvider>
    </SuppliersContextProvider>
  );
};

export default Purchase;
